// extracted by mini-css-extract-plugin
export default {"footerOuter":"styles_footerOuter__--MxU","footerInner":"styles_footerInner__xLM3A","centralised":"styles_centralised__6FWsH"};